import { loadRgbeTexture, loadTexture } from '../../loader';
import * as THREE from 'three';

export { createBackground };

async function createBackground(
    basePathBackground,
    backgroundFileName,
    useEnvMapAsBackground,
    { basePathEnvironment, environmentFileName } = {}
) {
    if (!backgroundFileName) return null;
    let background;
    if (useEnvMapAsBackground) {
        background = await loadRgbeTexture(environmentFileName, {
            basePath: basePathEnvironment,
        });
        background.mapping = THREE.EquirectangularReflectionMapping;
        return background;
    }
    background = await loadTexture(backgroundFileName, {
        basePath: basePathBackground,
    });
    background.mapping = THREE.EquirectangularReflectionMapping;
    return background;
}
